const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('exitingApp', ['Storage', '$window', function (Storage, $window) {
  return {
    replace: true,
    template: require('../../templates/directives/exiting-app.html'),
    controller: ['$scope', function ($scope) {
      const transferTo = Storage.get('transferring');
      if (transferTo) {
        console.log('exiting-app: navigating to external application: ', transferTo);
        Storage.remove('transferring');
        $window.location.replace(transferTo);
      } else {
        // It would be nice if we could reliably determine if there was previous history to navigate to.
        if (history.back() === undefined) {
          console.log('exiting-app: no history, navigate to root.');
          history.pushState({}, '', '/explore');
        }
      }
    }],
    controllerAs: 'exitingApp'
  };
}]);